var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container",on:{"click":_vm.handleGroupClick}},[_c('div',{staticClass:"group-item"},[_c('avatar',{attrs:{"src":_vm.group.avatar}}),_c('div',{staticClass:"group-name text-ellipsis"},[_vm._v(_vm._s(_vm.group.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }